
    <!-- Other Costs Widget-->
    <div class="row pt-3 pb-3">
    
        <div class="col-md-3 col1" align="center">
            <h2>{{othercostYearly | currency:'USD':'symbol'}} <i class="fa fa-line-chart"></i></h2>
            <h5>Total year to date<br />___________________</h5>
            <font *ngIf="othercostYearly == 0">NO RECORD FOR YEAR TO DATE</font>
            <font *ngIf="othercostYearly > 0">TOTAL COST FOR YEAR TO DATE</font>
        </div>
    
        <div class="col-md-3 col2" align="center">
            <h2>{{othercostMonthly | currency:'USD':'symbol'}} <i class="fa fa-line-chart"></i></h2>
            <h5>Total this month<br />___________________</h5>
            <font *ngIf="othercostMonthly == 0">NO RECORD FOR THE CURRENT MONTH</font>
            <font *ngIf="othercostMonthly > 0">TOTAL COST FOR THE CURRENT MONTH</font>
        </div>
    
        <div class="col-md-3 col3" align="center">
            <h2>{{othercostWeekly | currency:'USD':'symbol'}} <i class="fa fa-line-chart"></i></h2>
            <h5>Total this week<br />___________________</h5>
            <font *ngIf="othercostWeekly == 0">NO RECORD FOR THE CURRENT WEEK</font>
            <font *ngIf="othercostWeekly > 0">TOTAL COST FOR THE CURRENT WEEK</font>
        </div>
    
        <div class="col-md-3 col4" align="center">
            <h2>{{othercostRecentCost | currency:'USD':'symbol'}} <i class="fa fa-line-chart"></i></h2>
            <h5>Latest Other Cost<br />___________________</h5>
            <font *ngIf="othercostRecentCost == 0">NO COST ON RECORD</font>
            <font *ngIf="othercostRecentCost > 0"> COST FOR {{othercostRecentRego}} ON
                {{ (othercostRecentDate !== null) ? (othercostRecentDate | date: 'dd MMM yyyy') : "UNRECORDED DATE"  }}</font>
        </div>
    
    </div>

    <!--Feature Menu Icon-->
    <div class="row">
            <div class="col-md-12">
                <button type="button" class="btn btn-secondary btn-sm mb-1 mr-1" aria-expanded="false" placement="bottom" 
                ngbTooltip="Add New Cost" (click)="openOtherCostModal(null)">
                    <span class="sr-only">Add</span>
                    <i class="fa fa-lg fa-plus"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp;Add</span>
                </button>
                
                
                <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1" (click)="print(prefixCost)" placement="bottom" [disabled]="otherCount < 1"
                    ngbTooltip="Print List">
                    <i class="fa fa-lg fa-print"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Print</span>
                </button>

                <div class="btn-group mr-1">
                    <button type="button" class="btn btn-sm btn-secondary dropdown-toggle mb-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [disabled]="otherCount < 1"
                    placement="bottom" ngbTooltip="Export List">
                        <i class="fa fa-lg fa-download"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Export</span>
                    </button>
                    <div class="dropdown-menu fs-12">
                        <a (click)="otherCost_exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to CSV</a> 
                        <a (click)="otherCost_exportToExcel()" class="dropdown-item" href="javascript:void(0);">Export to Excel</a> 
                        <a (click)="otherCost_exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to PDF</a> 
                    </div>
                </div>
   
                <button type="button" [ngClass]="(showFilters)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1"
                    (click)="toggleFilters()" placement="bottom" ngbTooltip="Filter List">
                   <i class="fa fa-lg fa-filter"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Filter</span>
    
                </button>
                <button type="button" [ngClass]="(showSidebar)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1"
                    (click)="toggleSideBar()" placement="bottom" ngbTooltip="Toggle Sidebar">
                   <i class="fa fa-lg fa-toggle-right"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Sidebar</span>
    
                </button>
               
                <div class="btn-group mb-1">
                    <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                    placement="bottom" ngbTooltip="Show/Hide Columns">
                        <span class="sr-only">Toggle Dropdown</span>
                        <i class="fa fa-lg fa-check-square-o"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Columns</span>
                    </button>
                    <div class="dropdown-menu fs-12" style="width: 150px;">
                        <div class="col-md-12 mb-3 fs-12">
                            <input type="checkbox" [(ngModel)]="showDate">&nbsp;Date<br />
                            <input type="checkbox" [(ngModel)]="showRego">&nbsp;REGO<br />
                            <input type="checkbox" [(ngModel)]="showFleetID">&nbsp;Fleet ID<br />
                            <input type="checkbox" [(ngModel)]="showSupplier">&nbsp;Supplier<br /> 
                            <input type="checkbox" [(ngModel)]="showCost">&nbsp;Cost<br />
                            <input type="checkbox" [(ngModel)]="showFile">&nbsp;File<br />
                        </div>
                    </div>
                </div>

                <span *ngIf="myDropDown=='range'" class="pull-right" >&nbsp;
                    <input type="text"   width="120" class="mb-1" class="dateRangeInput" matInput
                    ngxDaterangepickerMd
                    [locale]="locale"
                    startKey="start"
                    endKey="end"
                    [showWeekNumbers]="true"
                    [showDropdowns]="true"
                    [(ngModel)]="otherCostDateRange"
                    (ngModelChange)="processOtherCostDateRange($event)"
                    name="daterange" 
                    [autoApply]="true"
                    opens="left"
                    drops="down"
                    
                    />
                </span>

                <select [(ngModel)]="myDropDown" (ngModelChange)="onChangeofOptions($event)" class="dateFilter  btn btn-sm  btn-secondary mb-1 pull-right">
                            <option value="today">Today</option>
                            <option value="week">This Week</option>
                            <option value="month">This Month</option>
                            <option value="year">This Year</option>
                            <option value="7">Last 7 days</option>
                            <option value="14">Last 14 days</option>
                            <option value="30">Last 30 days</option>
                            <option value="90">Last 90 days</option>
                            <option value="all">All Dates</option>
                            <option value="range">Custom date range</option>
                    </select>
            </div>
    </div>
    <br *ngIf="showFilters" />
    <div class="row pt-0">
        <div class="col-md-12">
            <div widget class="card border-0 box-shadow" *ngIf="showFilters">
                <div class="card-header border-0 text-muted">
                    <h5 class="mb-0">Search Other Cost List:</h5>
                    <div class="widget-controls"> 
                        <a data-widgster="close"class="transition" (click)="toggleFilters()"><i class="fa fa-times"></i></a>
                    </div>  
                </div>
                <div class="card-block card-header pt-0 widget-body">
                    <div class="row">
                        <div class="col-md-6">
                                <label>REGO:</label> 
                                <input type="text" class="form-control form-control-sm" (keyup)="updateFilter(prefixCost)" [(ngModel)]="filterOtherRego">
                        </div>
                        <div class="col-md-6">
                                <label>Supplier:</label> 
                                <select placeholder="Select"  class="form-control form-control-sm" [(ngModel)]="filterOtherProvider" (change)="updateFilter(prefixCost)"> 
                                    <option selected disabled>Select..</option>
                                    <option *ngFor="let pr of providers" value="{{pr.id}}">{{pr.company_name}}</option>
                                </select>
                        </div>
                    </div>   <br />
                    <div class="row" *ngIf="!isFilterEmpty || otherCostDateRange != ''">
                        <div class="col-md-12">
                            <button  type="button" class="btn btn-success btn-sm mb-1" (click)="resetFilters()">
                                    <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-filter"></i></span>
                                    <span >Reset Filters</span>
                            </button> &nbsp;
                        </div>
                            
                    </div>                                  
                </div>
            </div> 
        </div>
    </div>
    <br *ngIf="showFilters" />
    <ngx-loading [show]="loadingIndicator5"></ngx-loading>
    <div class="row pt-3">
        <div [ngClass]="(showSidebar) ? 'col-md-8' : 'col-md-12'" align="left">
            <span>
                Items: <span style="color: rgb(23, 98, 141);">{{ (totalOtherCost !== null) ?   (totalOtherCost) : "0"}}</span>   |  
                Average Amount: <span style="color: rgb(23, 98, 141);">{{ (averageOtherCostAmount  && averageOtherCostAmount !== null) ?   '$' + (averageOtherCostAmount | number:'1.2-2') : "0.00"}}</span> |
                Total Amount: <span style="color: rgb(23, 98, 141);">{{ (totalOtherCostAmount  && totalOtherCostAmount !== null) ?   '$' + (totalOtherCostAmount | number:'1.2-2') : "0.00"}}</span>
        </span>
            <ngx-datatable
                [loadingIndicator]="loadingIndicator"
                class="material"
                [rows]="othercost_rows"
                [columnMode]="'force'"
                [footerHeight]="40"
                [rowHeight]="'auto'"
                [limit]="10"
                [selected]="selected5"
                [selectionType]="'single'"
                (activate)="onActivate5($event)"
                (select)='onSelect5($event)'
                [scrollbarH]="true"
                >


                <ngx-datatable-column prop="id" name="Operations" headerClass="header" [width]="50">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div>
                            <a container="body" placement="top" title="Edit Other Cost" (click)="openOtherCostModal(row)"><i
                                    class="fa fa-lg fa-pencil"></i></a>&nbsp;
                            <a (click)="openDeleteOtherCostModal(row)" placement="right" title="Delete Other Cost"><i
                                    class="fa fa-lg fa-trash"></i></a>
                        </div>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Date" prop="date" headerClass="header" *ngIf="showDate" [width]="200">
                        <ng-template let-value="value" ngx-datatable-cell-template>
                                {{ (value !== null) ? (value | date: 'dd MMM yyyy') : "No Data"  }}
                        </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="REGO" prop="rego" headerClass="header" *ngIf="showRego" [width]="200">

                </ngx-datatable-column>
                <ngx-datatable-column name="Fleet ID" prop="fleet_id_num" headerClass="header" *ngIf="showFleetID" [width]="200">

                </ngx-datatable-column>
                <ngx-datatable-column name="Supplier" prop="company_name" headerClass="header" *ngIf="showSupplier" [width]="200">

                </ngx-datatable-column>
                <ngx-datatable-column name="Cost" prop="cost" headerClass="header-currency" *ngIf="showCost" [width]="200">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                        <div align="right" style="padding-right:20px"> {{ (value !== null) ?  (value | currency:'USD':'symbol') : "No Price"}}</div>
                    </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="File" prop="file"  headerClass="header" [width]="300" *ngIf="showFile">
                <ng-template let-value="value" ngx-datatable-cell-template>
                    <a href="{{fileStoragePath}}/othercosts/{{value}}" target="_new">{{value}}</a>
                </ng-template>
            </ngx-datatable-column>

            </ngx-datatable>
    </div>

    <!-- OTHERCOST DETAILS SIDEBAR -->
    <div class="col-md-4" *ngIf="showSidebar">
        <div widget class="card border-0 box-shadow selected-column">
            <div class="card-header transparent border-0 text-muted">
                <h5 class="mb-0">Other Cost Details:</h5>
            </div>
            <div class="card-body pt-0 widget-body">
                <ul>
                    <div *ngFor='let sel of selected5, let i = index'>
                        <div class="col-md-12 details">
                            Date: <strong>{{ sel.date | date: 'dd MMM yyyy' }}</strong>
                            <hr />
                            Fleet: <strong>{{sel.fleet_id_num}}</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                            Rego: <strong>{{sel.rego}}</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                            Driver: <strong >{{ (sel.driver !== null) ?  sel.driver : "No Data Recorded"}}</strong><br />
                            <hr />
                            Company Name: <strong>{{sel.company_name}}</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            Amount: <strong>{{sel.cost}}</strong>
                            <hr />
                            Description: <strong>{{sel.description}}</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                            Status: <strong>{{sel.status}}</strong>



                        </div> <br>
                        <div class="col-md-12">
                            <button type="button" class="btn btn-sm btn-secondary mb-1" (click)="openOtherCostModal(sel)">
                                <span class="badge badge-pill badge-white text-primary ml-1"><i
                                        class="fa fa-lg fa-pencil"></i></span>
                                Edit
                            </button> &nbsp;
                            <button type="button" class="btn btn-sm btn-danger mb-1"
                                (click)="openDeleteOtherCostModal(sel)">
                                <span class="badge badge-pill badge-white text-primary ml-1"><i
                                        class="fa fa-lg fa-trash"></i></span>
                                Delete
                            </button>
                            &nbsp;
                            <button *ngIf="!!sel.file" type="button" class="btn btn-sm btn-secondary mb-1">
                                <span class="badge badge-pill badge-white text-primary ml-1"><i
                                    class="fa fa-lg fa-file"></i></span>&nbsp;
                                <a  href="{{fileStoragePath}}/othercosts/{{sel.file}}" target="_new" style="text-decoration: none; color: white;">View File</a>
                            </button>
                        </div>
                    </div>
                    <li *ngIf="!selected5.length">No Selections</li>
                </ul>
            </div>
        </div>
    </div>
    <!--  END OTHER COST DETAILS SIDEBAR  -->

    </div> <!-- END ROW -->



<!-- START OF ADD OTHER COST FORM -->
<ng-template #modalOtherCost let-close="close">
    <div class="modal-header">
        <h5 class="modal-title" *ngIf="isEditMode==false">Add Other Cost</h5>
        <h5 class="modal-title" *ngIf="isEditMode==true">Edit Cost</h5>

        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="otherCostForm" novalidate (ngSubmit)="onSubmitOtherCost(otherCostForm.value)">
        <div class="modal-body">
            <div class="row pt-0">
                <div class="form-group col-md-4">
                    <h6>Driver:</h6>
                    <select [id]="driver_id" class="form-control form-control-sm" placeholder="Select" formControlName="driver_id">
                    <option disabled selected *ngIf="isEditMode==false">Select..</option>
                    <option *ngFor="let dr of drivers" value="{{dr.id}}">{{dr.full_name}} </option>
                    </select>
                </div>
                <div class="form-group col-md-4">
                    <h6>Fleet:</h6>
                    <select class="form-control form-control-sm" placeholder="Select" formControlName="fleet_id">
                    <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                    <option *ngFor="let fl of fleet" value="{{fl.id}}">{{fl.rego}} ({{fl.fleet_id_num}})</option>
                    </select>
                </div>
                <div class="form-group col-md-4">
                    <h6>Provider:</h6>
                    <select class="form-control form-control-sm" placeholder="Select" formControlName="provider_id">
                    <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                    <option *ngFor="let pr of providers" value="{{pr.id}}">{{pr.company_name}}</option>
                    </select>
                </div>
                <div class="form-group col-md-4">
                    <div class="form-group">
                        <h6 for="input-1">Cost<span class="text-danger">*</span> :</h6>
                        <div class="input-group input-group-sm">
                            <div class="input-group-prepend"><div class="input-group-text">$</div></div>
                            <input type="text" class="form-control form-control-sm" formControlName="cost" required>
                        </div>
                        <div *ngIf="otherCostForm.controls.cost.touched">
                            <div *ngIf="otherCostForm.controls.cost.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                            <div *ngIf="otherCostForm.controls.cost.errors?.pattern && !isCost() ">
                                <small class="text-danger">Cost must have a valid currency value.</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-4">
                    <div class="form-group">
                        <h6 for="input-1">Description<span class="text-danger">*</span>:</h6>
                        <div class=input-group>
                            <input type="text" class="form-control form-control-sm" formControlName="description" required>
                            <!-- <div class="input-group-append"><div class="input-group-text">L</div></div> -->
                        </div>
                        <div *ngIf="otherCostForm.controls.description.touched">
                            <div *ngIf="otherCostForm.controls.description.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                        </div>
                    <!-- <small *ngIf="!isCostValid()" class="text-danger">
                        Required.
                        </small> -->
                    </div>
                </div>
                <div class="form-group col-md-4">
                    <h6>Status<span class="text-danger">*</span> :</h6>
                    <select [id]="driver_id" class="form-control form-control-sm" placeholder="Select" formControlName="payment_status_id" required>
                        <option disabled selected *ngIf="isEditMode==false">Select..</option>
                        <option *ngFor="let ps of payment_statuses" value="{{ps.id}}">{{ps.name}}</option>
                    </select>
                    <div *ngIf="otherCostForm.controls.payment_status_id.touched">
                        <div *ngIf="otherCostForm.controls.payment_status_id.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-4" >
                    <h6>Date<span class="text-danger">*</span>:</h6>
                    <input formControlName="date" class="form-control form-control-sm" type="date" required>
                    <div *ngIf="otherCostForm.controls.date.touched">
                        <div *ngIf="otherCostForm.controls.date.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group" *ngIf ="(fileExists==true)">
                        <h6>File:</h6>
                        <label>{{othercost?.file}}</label> <button class="btn btn-sm btn-primary" type="button" (click)="removeFile(prefixCost)">Remove File</button>
                    </div>
                    <div class="form-group" *ngIf ="(fileExists==false)">
                        <h6>File:</h6>
                        <app-file-uploader (passFile)="getFile($event, prefixCost)"></app-file-uploader>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
            <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
            <button *ngIf="isEditMode==false" type="submit" class="btn btn-sm btn-success" [disabled]="!otherCostForm.valid || spinner == true">Save</button>
            <button *ngIf="isEditMode==true" type="submit" class="btn btn-sm btn-success" [disabled]="!otherCostForm.valid || spinner == true">Save Changes</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
        </div>
    </form>
</ng-template>
<!-- END OF MODAL ADD OTHER COST FORM -->

<!-- START OF DELETE OTHER COST FORM -->
<ng-template #modalDeleteOtherCost let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Delete Cost</h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row pt-0">
            <div class="col-md-12">
                <p class="mb-0">  Do you really want to delete this cost? </p>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-danger"  (click)="deleteOtherCost(othercost)"  [disabled]="spinner == true">Delete</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
    </div>
</ng-template>
<!-- END OF MODAL DELETE OTHER COST FORM -->

<!-- OTHER COSTS -->
<div id="print-section-othercosts" style="display:none">
    <table style="width:100%">
    <tr>
        <th align="left" *ngIf="showDate">DATE</th>
        <th align="left" *ngIf="showRego">REGO</th>
        <th align="left" *ngIf="showFleetID">FLEET ID</th>
        <th align="left" *ngIf="showSupplier">SUPPLIER</th>
        <th align="left" *ngIf="showCost">COST</th>
        <th align="left" *ngIf="showFile">FILE</th>
    </tr>
    <tr *ngFor="let row of othercost_rows">
        <td *ngIf="showDate">{{ (row.date !== null) ? (row.date | date: 'dd MMM yyyy') : ""  }}</td>
        <td *ngIf="showRego">{{row.rego}}</td>
        <td *ngIf="showFleetID">{{row.fleet_id_num}}</td>
        <td *ngIf="showSupplier">{{row.company_name}}</td>
        <td *ngIf="showCost">{{row.cost | currency:'USD':'symbol'}}</td>
        <td *ngIf="showFile">{{row.file}}</td>
    </tr>
</table>

</div>
    